<template>
<div v-if="ready" class="page">
  <a name="portfolio-overview"/>
  <p class="preheader">
     {{ portfolio.name }}
  </p>
  <p class="dustin-title ">
    Portfolio Overview
  </p>

  <br>
  <div class="columns">
    <div class="column is-half">
      <p class="preheader">
        Values-based Data Coverage
      </p>
      <br>
      <table class="table is-narrow">
        <thead>
          <th>Category</th>
          <th>Allocation</th>
          <th>Coverage</th>
        </thead>
        <tbody>
          <tr>
            <td>Public Equities, Corporate & Sovereign Bonds</td>
            <td>{{ cleanPercentage(portfolio.percent_corporate) }}%</td>
            <td>{{ cleanPercentage(portfolio.one_metric_coverage / portfolio.percent_corporate) }}%</td>
          </tr>
          <tr>
            <td>Other</td>
            <td>{{ cleanPercentage(1 - portfolio.percent_corporate) }}%</td>
            <td>N/A</td>
          </tr>
        </tbody>
      </table>
      <p class="dustin-label">
        Data Coverage
      </p>
        <p class="criteria">
          The scope of this report covers the impact of public equity, corporate debt, and sovereign debt, as well as community investment notes held directly or within mutual funds. The coverage number represents the % of companies within the category where there is some information on social + environmental impact.
        </p>
    </div>
    <div class="column is-half">
      <div class="small">
        <div v-if="chartImg">
          <img v-bind:src="chartImg">
        </div>
        <div v-else>
          <doughnut-chart :chart-data="datacollection" :options="chartOptions" ref="doughnut"></doughnut-chart>
        </div>
      </div>
    </div>
  </div><!-- columns -->
  <p class="preheader">
    Methodological Approach
  </p>
  <div class="columns">
    <div class="column is-three-fifths">
      <p class="dustin-label">
        Methodology
      </p>
      <p class="criteria">
        Data on corporates within public equity and corporate debt is collected according to the YourStake.org methodology described in previous pages. Community investment note data is aggregated from fund manager reporting.
      </p>
    </div>
    <div class="column is-two-fifths">
      <p class="dustin-label">
        Fund Holdings Coverage
      </p>
      <p class="criteria">
        Coverage of fund holdings data is updated monthly from SEC filings. Due to reporting lag, recent holdings changes within a three month window may not be reflected.
      </p>
    </div>
  </div>
  <p class="preheader">
    Benchmark
  </p>
  <br>
  <div class="columns is-centered is-vcentered">
    <div class="column has-text-centered">
      <p class="highlights">
        {{ benchmark.name ? benchmark.name : 'Blended Benchmark' }}
      </p>
    </div><!-- column -->
    <div class="column has-text-left ">
      <p class="dustin-label">
        Methodology
      </p>
      <template v-if="!benchmark.name">
        <p class="criteria">
          Blended benchmarks are assigned based on the investment style category of the funds constituent to the portfolio.
        </p>
        <br>
        <p class="criteria">
          Each benchmark is represented by an ETF that tracks that benchmark. Benchmark holdings are assessed based on the quarterly SEC disclosure of the ETF holdings.
        </p>
        <br>
        <p class="criteria">
          The style category associated with each fund constituent is disclosed in Appendix A.
        </p>
      </template>
      <template v-else>
        <p class="criteria">
          This benchmark was chosen by the advisor. This portfolio is compared on a relative basis across available metrics with the benchmark.
        </p>
      </template>
    </div><!-- column -->
  </div>


<!-- page-->

</div>
</template>

<script>
 import DoughnutChart from './subcomponents/DoughnutChart.js'

  export default {
    components: {
      DoughnutChart,
    },
    data () {
      return {
        datacollection: {},
        chartImg: '',
      }
    },
    props: {
      portfolio: Object,
      benchmark: Object
    },
    computed: {
      ready: function() {
        // Portfolio percent_corporate should be automatically calculated. In
        // the case that it's not, favor hiding this page entirely over
        // crashing.
        return this.portfolio && this.portfolio.percent_corporate;
      },
      chartOptions: function() {
        return {
          animation: false
        }
      }
    },
    methods: {
      cleanPercentage: function(pct) {
        const clipped = Math.abs(Math.min(pct, 1) * 100);
        return clipped.toLocaleString(undefined, {maximumFractionDigits: 0})
      }
    },
    mounted: function() {
      this.datacollection = {
        labels: [ `ESG Data Coverage`],
        datasets: [
          {
            label: ['Corpoate', 'Non-Corporate', 'Community Investment'],
            backgroundColor: ['#043927', 'darkgrey', 'lightgreen'],
            borderWidth: 10,
            weight: .5,
            data: [this.portfolio.one_metric_coverage, 1-this.portfolio.one_metric_coverage, .003],
          },
        ]
      }
      this.$nextTick(() => {
        this.chartImg = this.$refs.doughnut.$data._chart.toBase64Image();
      });

    },
  }

</script>

<style lang="css" scoped>
  .tableofcontents {
    padding: 6rem;
  }
  .small {
    max-width: 600px;
  }


</style>
